<template>
	<FooterBar
		:vuetify-options="vuetifyOptions"
		hide-cgu-link
		hide-sitemap-link
		hide-social-media-links
		hide-legal-notice-link
		hide-cookies-link
		:link-items="linkItems"
	>
		<template #logo>
			<Logo
				v-if="isMobile"
				hide-signature
				size="small"
				fill="#fff"
				class="logo"
			/>
		</template>

		<template #default>
			<VDivider
				v-if="isMobile"
				class="d-none"
			/>
		</template>

		<template #prepend>
			<a
				href="/mentions-legales"
				class="text--secondary my-3 mx-4"
			>
				Mentions légales et CGU
			</a>
		</template>

		<template #append>
			<a
				href="https://www.ameli.fr/assure/protection-donnees-personnelles"
				class="text--secondary my-3 mx-4"
			>
				Protection des données personnelles
			</a>

			<a
				href="https://www.ameli.fr/"
				class="text--secondary my-3 mx-4"
			>
				Site ameli
			</a>
		</template>
	</FooterBar>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { LinkItem } from '@cnamts/vue-dot/src/patterns/FooterBar/types';

	@Component
	export default class AppFooter extends Vue {
		version = process.env.VUE_APP_VERSION;
		linkItems: LinkItem[] = [
			{
				text: 'Accessibilité : non conforme',
				to: '/accessibilite'
			}
		];

		vuetifyOptions = {
			goTopBtn: {
				color: 'white'
			}
		};

		get isMobile(): boolean {
			return this.$vuetify.breakpoint.xs;
		}
	}
</script>

<style lang="scss" scoped>
	@import '@cnamts/design-tokens/dist/tokens';

	.vd-footer-bar {
		background: #424444 !important;

		@media only screen and (max-width: 599px) {
			> :first-child {
				margin-top: 38px !important;
				margin-bottom: 62px !important;
			}
		}
	}

	.vd-footer-bar :deep() {
		.text--primary,
		.text--secondary {
			color: #fff !important;
		}

		p.text--secondary {
			color: rgba(255, 255, 255, .7) !important;
		}

		.v-divider {
			background: $vd-grey-lighten-97;
		}
	}
</style>
